import { useState } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import DropDown from "components/DropDown";
import api from "Services/API";
import ResponseHandler from "components/ResponseHandler";
import { useQuery } from "@tanstack/react-query";
import "./styles.scss";

const FormSelectBox = (props) => {
    const {
        input,
        onChange,
        defaultValue,
        disabledSelect,
        value,
        name,
        // hasNotShowAll,
        vendorSelected,
        isFoodSelectBox = false,
    } = props;

    const service = () => {
        return api.get(`${input.data}`);
    };

    const {
        data: responseData,
        isLoading,
        isError,
    } = useQuery(["api-get-data", input.data], service, {
        enabled: input.data_type === "api",
        refetchIntervalInBackground: false,
    });

    const [searchValue, setSearchValue] = useState("");
    const optionDefaultValue =
        input?.flag === "defaultSelect"
            ? defaultValue || "انتخاب کنید"
            : "انتخاب کنید";
    const jsonData =
        (input.type === "json" && input.data && JSON.parse(input.data)) || [];

    const getTitle = () => {
        if (responseData?.config?.url.includes("/branch")) {
            return responseData?.data?.data?.find(
                (vendorItem) => vendorItem.vendor_id === defaultValue
            )?.vendor_title;
        } else if (responseData?.config?.url?.includes("/customer")) {
            return responseData?.data?.data?.find(
                (el) => el.id === defaultValue
            )?.name;
        }
        return responseData?.data?.data.find(
            (vendorItem) => vendorItem.id === defaultValue
        )?.title;
    };
    return (
        input &&
        (input.data_type === "api" ? (
            <ResponseHandler loading={isLoading} error={isError} isInput>
                <DropDown
                    className="w-100"
                    name={name}
                    title={input.label}
                    // hasShowAll={!hasNotShowAll}
                    data={responseData?.data?.data.filter(
                        (el) =>
                            el.name?.includes(searchValue) ||
                            el.title?.includes(searchValue)
                    )}
                    disabled={disabledSelect}
                    disabledSelect={disabledSelect}
                    onChangeSearch={setSearchValue}
                    getSelectedItem={onChange}
                    defaultActiveItem={{
                        id: defaultValue,
                        title: getTitle(),
                    }}
                    search
                    vendorSelected={vendorSelected}
                    isFoodSelectBox={isFoodSelectBox}
                    inputData={input}
                />
            </ResponseHandler>
        ) : input.data_type === "array" ? (
            <Form.Control
                aria-label="Default select"
                type="text"
                as="select"
                name={input.name}
                onChange={onChange}
                defaultValue={defaultValue}
                disabled={disabledSelect}
                disabledSelect={disabledSelect}
                value={value === "" ? 0 : value}
                style={{
                    paddingLeft: "10px",
                }}
            >
                <option value="0">انتخاب کنید</option>
                {jsonData.map((item) => (
                    <option key={item.id} value={item.id}>
                        {item.title || item.name}
                    </option>
                ))}
            </Form.Control>
        ) : (
            <Form.Control
                className="form-control-select"
                aria-label="Default select"
                type="text"
                as="select"
                name={input.name}
                onChange={onChange}
                value={value === "" ? 0 : value}
                defaultValue={defaultValue}
                disabled={disabledSelect}
                disabledSelect={disabledSelect}
                style={{
                    paddingLeft: "10px",
                }}
            >
                <option value="0">{optionDefaultValue}</option>
                {Object.keys(jsonData).map((item, index) => (
                    <option key={index} value={jsonData[item]}>
                        {item}
                    </option>
                ))}
            </Form.Control>
        ))
    );
};

FormSelectBox.propTypes = {
    value: PropTypes.string,
    input: PropTypes.object,
    defaultValue: PropTypes.any,
    name: PropTypes.string,
    onChange: PropTypes.func,
    hasNotShowAll: PropTypes.bool,
    disabledSelect: PropTypes.any,
    vendorSelected: PropTypes.bool,
    isFoodSelectBox: PropTypes.bool,
};

export default FormSelectBox;
